import Typed from "react-typed";
import { Link } from "react-router-dom";
import ImgHero from "../assets/ImgHero.png";
import { useTranslation } from "react-i18next";

const Hero = ({ id }) => {
  const { t } = useTranslation();

  return (
    <section
      id={id}
      className="bg-[#F0F8FF]  py-28  relative overflow-hidden"
    >
      {/* Background gradient blur */}
      <div className="absolute inset-0 blur-xl pointer-events-none" />

      <div className="relative flex flex-col-reverse md:flex-row max-w-7xl mx-auto px-4 py-16 md:py-28 gap-10 text-gray-600 md:px-8">
        {/* Left content */}
        <div className="flex-1 space-y-5 max-w-xl mx-auto md:mx-0 text-center md:text-left">
          {/* Headline */}
          <h1
            className="text-3xl text-gray-800 font-extrabold md:text-4xl lg:text-5xl"
            data-aos="fade-up"
          >
            {t("hero.headline")}
          </h1>

          {/* Typed solutions */}
          <div
            className="flex flex-col sm:flex-row justify-center md:justify-start items-center gap-x-2 gap-y-1 md:gap-x-4"
            data-aos="zoom-in"
          >
            <span className="text-xl md:text-2xl font-semibold">
              {t("hero.solutions")}
            </span>
            <Typed
              className="text-xl md:text-2xl font-semibold text-[#00df9a]"
              strings={t("hero.typed", { returnObjects: true })}
              typeSpeed={100}
              backSpeed={80}
              loop
            />
          </div>

          {/* Subtext */}
          <p
            className="text-lg md:text-xl text-gray-900 font-medium"
            data-aos="fade-right"
          >
            {t("hero.subtext")}
          </p>

          {/* Image for mobile view */}
          <div className="flex justify-center md:hidden" data-aos="fade-left">
            <img
              src={ImgHero}
              className="w-full max-w-sm sm:max-w-md mt-6"
              alt="Hero illustration"
              loading="lazy"
            />
          </div>

          {/* Call-to-action buttons */}
          <div className="flex justify-center md:justify-start gap-x-3 sm:text-sm">
            <Link
              to="/expertises"
              className="flex items-center justify-center gap-x-1 px-4 bg-[#00171f] text-[#00df9a] text-center w-[200px] font-medium duration-150 hover:bg-gray-700 active:bg-gray-900 rounded-full my-6 py-3 md:inline-flex"
              data-aos="fade-up"
            >
              {t("hero.cta")}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                className="w-5 h-5"
              >
                <path
                  fillRule="evenodd"
                  d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                  clipRule="evenodd"
                />
              </svg>
            </Link>
          </div>
        </div>

        {/* Right image for desktop */}
        <div className="flex-1 hidden md:flex justify-center" data-aos="fade-left">
          <img
            src={ImgHero}
            className="max-w-xl"
            alt="Hero illustration"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
